import PropTypes from "prop-types"

import { genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"
import {
    SendSMSContactFilter,
    SendSMSTextFilter,
    SendSMSStatusClickedFilter,
    SendSMSStatusConvertedFilter,
    SendSMSReceivedStatusFilter,
    SendSMSDateCreatedBeforeFilter,
    SendSMSDateCreatedAfterFilter,
    SendSMSCampaignFilter,
} from "shared/search/containers/Filter/SendSMSFilters"

export const SendSMSRecipientsFilterGroup = (props) => genericFilterGroup(props)
SendSMSRecipientsFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendSMSRecipientsFilterGroup.defaultProps = {
    filters: [SendSMSContactFilter],
    uniqueFilterGroupId: "sendSMSRecipientsFilterGroup",
    displayLabel: "Recipients",
    helpText: "Filter SMS by their recipients",
}

export const SendSMSTextFilterGroup = (props) => genericFilterGroup(props)

SendSMSTextFilterGroup.defaultProps = {
    filters: [SendSMSTextFilter],
    uniqueFilterGroupId: "SendSMSTextFilterGroup",
    displayLabel: "Texts",
    helpText: "Filter SMS by their text campaigns",
}

export const SendSMSStatusFilterGroup = (props) => genericFilterGroup(props)
SendSMSStatusFilterGroup.defaultProps = {
    filters: [SendSMSStatusClickedFilter, SendSMSReceivedStatusFilter, SendSMSStatusConvertedFilter],
    uniqueFilterGroupId: "SendSMSStatusFilterGroup",
    displayLabel: "Status",
    helpText: "Filter recipient by the message status",
}

export const SendSMSDateCreatedFilterGroup = (props) => genericFilterGroup(props)
SendSMSDateCreatedFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendSMSDateCreatedFilterGroup.defaultProps = {
    filters: [SendSMSDateCreatedBeforeFilter, SendSMSDateCreatedAfterFilter],
    uniqueFilterGroupId: "sendSMSDateCreatedFilterGroup",
    displayLabel: "Date",
}

export const SendSMSCampaignFilterGroup = (props) => genericFilterGroup(props)
SendSMSCampaignFilterGroup.defaultProps = {
    filters: [SendSMSCampaignFilter],
    uniqueFilterGroupId: "SendSMSCampaignFilterGroup",
    displayLabel: "Campaigns",
}
